// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Card, MenuItem } from "@mui/material";
import DashboardLayout from "../../components/layoutContainers/dashboardLayout";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";
import SoftBox from "../../components/common/softBox";
import SoftTypography from "../../components/common/softTypography";
import SoftButton from "../../components/common/softButton";
import Table from "../../components/tables/table";
import ActionMenu from "../../components/common/custom/action-menu";
import { deleteStaffData, getStaffData } from "../../features/staff";
import { toast } from "react-toastify";

const StaffTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: staffs, status, pagination } = useSelector(
    (state: any) => state.staff
  );

  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    dispatch(getStaffData({ page: pageIndex, limit: pageSize }));
  }, [dispatch, pageIndex, pageSize]);

  useEffect(() => {
    if (status && staffs) {
      setData(staffs);
      setTotalRows(pagination?.total || 0);
    }
  }, [status, staffs, pagination]);

  const handleDelete = (id: string) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this user?"
    );
    if (isConfirmed) {
      dispatch(deleteStaffData({ id })).then((action: any) => {
        if (deleteStaffData.rejected.match(action)) {
          toast.error(msg || "Failed to delete staff.");
        } else {
          toast.success("Staff deleted successfully.");
        }
        dispatch(getStaffData({ page: pageIndex, limit: pageSize }));
      });
    }
  };

  const columns = [
    {
      header: "ID",
      accessorKey: "id",
      id: "id",
      align: "center",
      cell: (info: any) => <span>{Number(info.getValue())}</span>,
    },
    {
      header: "Name",
      accessorKey: "name",
      id: "name",
      align: "left",
      cell: (info: any) => <strong>{info.getValue()}</strong>,
    },
    {
      header: "Email",
      accessorKey: "email",
      id: "email",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Role",
      accessorKey: "role_id",
      id: "role_id",
      align: "left",
      cell: (info: any) => (
        <span>{info.getValue()?.name || info.getValue() || "—"}</span>
      ),
    },
    {
      header: "Company Code",
      accessorKey: "companyCode",
      id: "companyCode",
      align: "left",
      cell: (info: any) => <span>{info.getValue() || "—"}</span>,
    },
    {
      header: "Created At",
      accessorKey: "created_at",
      id: "created_at",
      align: "left",
      cell: (info: any) => (
        <span>
          {info.getValue() ? new Date(info.getValue()).toLocaleDateString() : "—"}
        </span>
      ),
    },
    {
      header: "Actions",
      id: "actions",
      align: "center",
      cell: (info: any) => {
        const user = info.row.original;
        const id = info.row.original._id;
        return (
          <ActionMenu>
            <MenuItem onClick={() => navigate("/staffs/edit", { state: { user } })}>
              Edit Staff
            </MenuItem>
            <MenuItem onClick={() => handleDelete(id)}>
              Delete Staff
            </MenuItem>
          </ActionMenu>
        );
      },
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={3}
            >
              <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
                Staff Table
              </SoftTypography>
              <SoftBox sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <SoftButton
                  onClick={() => navigate("/staffs/add")}
                  variant="contained"
                  color="final"
                  style={{ textTransform: "Capitalize" }}
                >
                  Add Staff
                </SoftButton>
              </SoftBox>
            </SoftBox>
            <Table
              columns={columns}
              data={data}
              pageIndex={pageIndex}
              pageSize={pageSize}
              totalRows={totalRows}
              onPageChange={(newPageIndex) => setPageIndex(newPageIndex)}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            />
          </Card>
        </SoftBox>
      </SoftBox>
    </DashboardLayout>
  );
};

export default StaffTable;